module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="card-grid wmui-card-view">\n    <h1></h1>\n</div>\n';

}
return __p
}